import type { KpiDependent } from "../types/kpi";

/** Secondary context for a dependent KPI (activity / template names). */
export function formatKpiDependentContext(dep: KpiDependent): string {
  const parts: string[] = [];
  if (dep.activity_name) parts.push(dep.activity_name);
  if (dep.report_template_name) parts.push(dep.report_template_name);
  return parts.join(" · ");
}

export function kpiDependentRowKey(dep: KpiDependent, index?: number): string {
  return [
    dep.kpi_id,
    dep.activity_id ?? "",
    dep.report_template_id ?? "",
    index ?? "",
  ].join(":");
}
